"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syncWheel2 = exports.storageKey = exports.saveState = exports.loadState = exports.deviceId = void 0;
var _wheel2Logic = require("./wheel2Logic");
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
} // Background sync of the "Roue 2" plays. The wheel never waits for it: plays are queued in the
// device state (state.pending) and pushed whenever the network allows; failures are just retried.
var storageKey = function storageKey(cellId, config) {
  return "wheel2:".concat(cellId, ":").concat(config.stockVersion, ":").concat(config.testMode ? 'test' : 'real');
};
exports.storageKey = storageKey;
var loadState = function loadState(key) {
  try {
    var raw = window.localStorage.getItem(key);
    return raw ? _objectSpread(_objectSpread({}, (0, _wheel2Logic.emptyState)()), JSON.parse(raw)) : (0, _wheel2Logic.emptyState)();
  } catch (e) {
    return (0, _wheel2Logic.emptyState)();
  }
};
exports.loadState = loadState;
var saveState = function saveState(key, state) {
  try {
    window.localStorage.setItem(key, JSON.stringify(state));
  } catch (e) {/* storage unavailable: counters stay in memory */}
};
exports.saveState = saveState;
var deviceId = function deviceId() {
  try {
    var id = window.localStorage.getItem('wheel2:device');
    if (!id) {
      id = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
      window.localStorage.setItem('wheel2:device', id);
    }
    return id;
  } catch (e) {
    return 'unknown';
  }
};
exports.deviceId = deviceId;
var running = false;

// Pushes the queued plays and refreshes the shared counters. Always resolves (never throws).
var syncWheel2 = exports.syncWheel2 = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function (_ref2) {
    var backEndUri = _ref2.backEndUri,
      cellId = _ref2.cellId,
      config = _ref2.config;
    return /*#__PURE__*/_regenerator().m(function _callee() {
      var key, before, toSend, res, body, after, sent, counts, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(running || !backEndUri || typeof fetch === 'undefined')) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            if (!(typeof navigator !== 'undefined' && navigator.onLine === false)) {
              _context.n = 2;
              break;
            }
            return _context.a(2);
          case 2:
            running = true;
            _context.p = 3;
            key = storageKey(cellId, config);
            before = loadState(key); // test plays never use up the stock: drop them instead of sending them
            toSend = (before.pending || []).filter(function (p) {
              return !p.test;
            }).slice(0, 200);
            if (!config.testMode) {
              _context.n = 4;
              break;
            }
            if ((before.pending || []).length) saveState(key, _objectSpread(_objectSpread({}, before), {}, {
              pending: []
            }));
            return _context.a(2);
          case 4:
            if (!toSend.length) {
              _context.n = 6;
              break;
            }
            _context.n = 5;
            return fetch("".concat(backEndUri, "/wheel2/sync"), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                cellId: cellId,
                deviceId: deviceId(),
                stockVersion: config.stockVersion,
                plays: toSend
              })
            });
          case 5:
            res = _context.v;
            _context.n = 9;
            break;
          case 6:
            if (!config.shareStock) {
              _context.n = 8;
              break;
            }
            _context.n = 7;
            return fetch("".concat(backEndUri, "/wheel2/").concat(cellId, "/counts?version=").concat(config.stockVersion));
          case 7:
            res = _context.v;
            _context.n = 9;
            break;
          case 8:
            return _context.a(2);
          case 9:
            if (res.ok) {
              _context.n = 10;
              break;
            }
            return _context.a(2);
          case 10:
            _context.n = 11;
            return res.json();
          case 11:
            body = _context.v;
            // re-read: the player may have spun while the request was in flight
            after = loadState(key);
            sent = new Set(toSend.map(function (p) {
              return p.id;
            }));
            after.pending = (after.pending || []).filter(function (p) {
              return !sent.has(p.id);
            });
            if (body.counts) {
              counts = {};
              body.counts.forEach(function (c) {
                counts[c.prize_key] = c.count;
              });
              after.server = {
                version: config.stockVersion,
                counts: counts,
                at: Date.now()
              };
            }
            saveState(key, after);
            _context.n = 13;
            break;
          case 12:
            _context.p = 12;
            _t = _context.v;
          case 13:
            _context.p = 13;
            running = false;
            return _context.f(13);
          case 14:
            return _context.a(2);
        }
      }, _callee, null, [[3, 12, 13, 14]]);
    })();
  });
  return function syncWheel2(_x) {
    return _ref.apply(this, arguments);
  };
}();